<template><div class="report-list">
  <div class="group" v-if="incomplete.length">
    <em>Scheduled</em>
    <ul>
      <li v-for="r in incomplete"
          :key="'report-'+r[0]">
        {{ r[1] }}
        <span v-if="r[2] > 0" class="progress">
          {{ Math.round(r[2] * 100) }}%
        </span>
        <button v-else @click="forceReport(r[0])">Run Now</button>
      </li>
    </ul>
  </div>
  <div class="group" v-if="complete.length">
    <em>Completed</em>
    <ul>
      <li v-for="r in complete"
          :key="'report-'+r[0]">
        <a v-if="!r[3]"
            :href="'/report/'+r[0]+'/pdf/'"
            target="_blank"
           >
           {{ r[1] }}
           <small>{{ fsize(r[4]) }}</small>
        </a>
        <span v-else v-html="r[1] + ' <b>failed.</b>'" class="error" />
        {{ ' ' }}
        <button @click="rerunReport(r[0])">Rerun</button>
        <button @click="rerenderReport(r[0])">Rerender</button>
      </li>
    </ul>
  </div>
  <p v-if="!unit">
    <i>Loading...</i>
  </p>
  <p v-else-if="!complete.length && !incomplete.length">
    <i>There are no reports available for this unit.</i>
  </p>
</div></template>
<script>
import api from '../api'
import { fsize_display } from '../util'
export default {
  name: 'report-list',
  props: ['unitId'],
  computed: {
    unit() {
      return this.$store.state.units[this.unitId]
    },
    complete() {
      let rv = []
      if (this.unit) {
        for (const r of this.unit.reports) {
          if (r[4])
            rv.push(r)
        }
      }
      return rv
    },
    incomplete() {
      let rv = []
      if (this.unit) {
        for (const r of this.unit.reports) {
          if (!r[4])
            rv.push(r)
        }
      }
      return rv
    },
  },
  methods: {
    rerunReport(rid) { api.rerunReport({ rid }) },
    rerenderReport(rid) { api.rerenderReport({ rid }) },
    forceReport(rid) { api.forceReport({ rid }) },
    fsize(bytes) { return fsize_display(bytes) },
  },
}
</script>
<style lang="scss" scoped>
  .report-list {
    ul {
      list-style-type: circle;
      padding-inline-start: 1.3em;
      .error {
        font-weight: normal;
      }
      small {
        background: #ddd;
        border-radius: 2px;
        padding: 1px 2px;
        border: 1px solid #ccc;
        text-decoration: none;
        display: inline-block;
      }
    }
  }

</style>
